import React from "react";

// 原価ヘッダ描画をまとめて返す。
export function createGenkaHeaderRenderer(deps) {
    const {
        PANEL_TYPE,
        entrydataRef,
        genkaPattern,
        genkaCurrency,
        genkaCurrencyOptions,
        isEmpty,
        DicVal,
        layoutDisplayName,
        genkaPatternLabelByNo,
        deriveGenkaPatternFromEntry,
        findGenkaCurrencyLayoutMeta,
        isGenkaCurrencyEditableByLayout,
        shouldForceGenkaCurrencyJpy,
        resolveGenkaCurrencyFromEntry,
        genkaCurrencyDisplayLabel,
        handleGenkaCurrencyChanged
    } = deps;

    // 原価ヘッダ（パターン/通貨）を描画する。
    function renderGenkaHeader() {
        const patternHeaderLabel = layoutDisplayName(
            ["SSDGM_GENKAPATTERN", "SSDGM_GENKA_PATTERN", "GENKA_PATTERN"],
            [PANEL_TYPE.GENKA_SUMMARY, PANEL_TYPE.GENKA, "127", "126", "19", "t2", "genka"],
            "原価パターン"
        );
        const derivedGenkaPattern = genkaPatternLabelByNo(deriveGenkaPatternFromEntry(entrydataRef.current));
        const patternDisplay = String(genkaPattern ?? "").trim() || (isEmpty(entrydataRef.current) ? "" : derivedGenkaPattern);
        const currencyHeaderLabel = String(DicVal(findGenkaCurrencyLayoutMeta(), "columnnm", "通貨単位") ?? "通貨単位");
        const currencyEditable = isGenkaCurrencyEditableByLayout() && !shouldForceGenkaCurrencyJpy(entrydataRef.current);
        const currencySelectable = currencyEditable && Array.isArray(genkaCurrencyOptions) && genkaCurrencyOptions.length !== 0;
        const currencyRaw = String(
            !isEmpty(genkaCurrency)
                ? genkaCurrency
                : resolveGenkaCurrencyFromEntry(entrydataRef.current)
        );
        const currencyDisplay = genkaCurrencyDisplayLabel(currencyRaw);

        return (
            <div className="kakousiji-genka-header">
                <div className="kakousiji-genka-header__left">
                    <div className="kakousiji-genka-header__group">
                        <div className="kakousiji-genka-header__label">{patternHeaderLabel}</div>
                        <div className="kakousiji-genka-header__value kakousiji-genka-header__value--pattern">
                            {patternDisplay}
                        </div>
                    </div>
                    <div className="kakousiji-genka-header__group">
                        <div className="kakousiji-genka-header__label">{currencyHeaderLabel}</div>
                        <div className="kakousiji-genka-header__value">
                            {currencySelectable ? (
                                <select
                                    value={genkaCurrency}
                                    onChange={(e) => handleGenkaCurrencyChanged(e.target.value)}
                                    className="kakousiji-genka-header__select"
                                >
                                    {genkaCurrencyOptions.map((v) => (
                                        <option key={"genka_cur_" + v} value={v}>
                                            {genkaCurrencyDisplayLabel(v)}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <div className="kakousiji-genka-header__currency-text">
                                    {currencyDisplay}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="kakousiji-genka-header__right">
                    <div className="kakousiji-genka-header__total">
                        <span className="kakousiji-genka-header__total-bar"></span>
                        <span>合計</span>
                    </div>
                </div>
            </div>
        );
    }

    return {
        renderGenkaHeader
    };
}
